<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">

    <ion-title class="ion-text-center header-title">{{ 'PICK_SLOT.PICK_SLOT' | translate }}</ion-title>

    <!--<ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="../../"></ion-back-button>
    </ion-buttons>-->

    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button (click)="navigateToServicePick()" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

    <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>

<ion-progress-bar *ngIf="'restavracija-strelec' === real?.slug || 'jaz-by-me' === real?.slug" style="height: 2px; margin-bottom: 20px;" color="secondary" value=".60" buffer="1"></ion-progress-bar>


<ion-content >
  <ion-grid fixed class="ion-no-padding">

  <!--app-stepper [currentStep]="2"></app-stepper-->

  <ion-grid class="ion-no-padding stepper" style="padding-bottom:10px;" *ngIf="'restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug" >
    <ion-row  class="ion-no-padding">
      <ion-col class="ion-no-padding" size="4">
        <ion-button (click)="navigateToServicePick()" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        disabled="false">
          <div>{{ 'PICK_SLOT.HOME' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button  color="secondary" mode="ios" class="btn--small stepper__btn--active ion-no-padding ion-no-margin"
        expand="full" disabled="false">
          <div>{{ 'PICK_SLOT.PICK_SLOT' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button [routerLink]="['../../../../predogled']" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        [disabled]="!pick?.isCombinationPicked()" >
          <div>{{ 'PICK_SLOT.PREVIEW' | translate }}</div>
        </ion-button>
      </ion-col>

    </ion-row>
  </ion-grid>

  <ion-list style="padding-bottom:0px; padding-top:0px; background-color: white; position: sticky; top: 0; left: 0; right: 0; z-index: 9999;"  >

  <ion-item  style="background-color: white; z-index: 999;">

    <span slot="end" style="color:#11324D">{{ 'PICK_SLOT.TABLE_FOR' | translate }}</span>

    <ion-select #mySelect  slot="end" style="margin-left: 10px; margin-right: -10px; padding-right: 15px; color: white; font-weight: bold;" [style.background-color]="('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug)?'#0100ee':'#C1CfC0'" *ngIf="pick?.partySize" interface="popover" [(ngModel)]="pick.partySize" (ionChange)="onPartySizeChange($event)" placeholder="Število oseb">
      
      <ion-select-option [value]="1">1 {{ 'PICK_SLOT.PERSON_1' | translate }}</ion-select-option>
      <ion-select-option [value]="2">2 {{ 'PICK_SLOT.PERSONS_2' | translate }}</ion-select-option>
      <ion-select-option [value]="3">3 {{ 'PICK_SLOT.PERSONS_3' | translate }}</ion-select-option>
      <ion-select-option [value]="4">4 {{ 'PICK_SLOT.PERSONS_4' | translate }}</ion-select-option>
      <ion-select-option [value]="5">5 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>


      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 6 )" [value]="6"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 6">{{ 'PICK_SLOT.GROUP' | translate }} </span>6 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 7 )" [value]="7"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 7">{{ 'PICK_SLOT.GROUP' | translate }} </span>7 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 8 )" [value]="8"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 8">{{ 'PICK_SLOT.GROUP' | translate }} </span>8 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 9 ) && 'jaz-by-me' !== real?.slug" [value]="9"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 9">{{ 'PICK_SLOT.GROUP' | translate }} </span>9 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 10 ) && 'jaz-by-me' !== real?.slug" [value]="10"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 10">{{ 'PICK_SLOT.GROUP' | translate }} </span>10 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 11 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="11"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 11">{{ 'PICK_SLOT.GROUP' | translate }} </span>11 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 12 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="12"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 12">{{ 'PICK_SLOT.GROUP' | translate }} </span>12 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 13 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="13">{{ 'PICK_SLOT.GROUP' | translate }} 13 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 14 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="14">{{ 'PICK_SLOT.GROUP' | translate }} 14 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 15 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug"[value]="15">{{ 'PICK_SLOT.GROUP' | translate }} 15 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 16 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="16">{{ 'PICK_SLOT.GROUP' | translate }} 16 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 18 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="18">{{ 'PICK_SLOT.GROUP' | translate }} 18 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 19 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="19">{{ 'PICK_SLOT.GROUP' | translate }} 19 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 20 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="20">{{ 'PICK_SLOT.GROUP' | translate }} 20 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 21 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="21">{{ 'PICK_SLOT.GROUP' | translate }} 21 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 22 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="22">{{ 'PICK_SLOT.GROUP' | translate }} 22 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 23 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="23">{{ 'PICK_SLOT.GROUP' | translate }} 23 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 24 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="24">{{ 'PICK_SLOT.GROUP' | translate }} 24 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 25 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="25">{{ 'PICK_SLOT.GROUP' | translate }} 25 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 30 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="30">{{ 'PICK_SLOT.GROUP' | translate }} 30 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
       <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 35 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="35">{{ 'PICK_SLOT.GROUP' | translate }} 35 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 40 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="40">{{ 'PICK_SLOT.GROUP' | translate }} 40 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 50 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="50">{{ 'PICK_SLOT.GROUP' | translate }} 50 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 60 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="60">{{ 'PICK_SLOT.GROUP' | translate }} 60 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 70 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="70">{{ 'PICK_SLOT.GROUP' | translate }} 70 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="real.contactUsPartySize" [value]="999">{{ 'PICK_SLOT.XL_GROUP' | translate }}</ion-select-option>

    </ion-select>

  </ion-item>


</ion-list>

  <app-days-calendar [real]="real" [selectedDay]="selectedDay" (onDaySelected)="onDaySelected($event)" [days$]="days$"></app-days-calendar>
  
  <ion-grid class="ion-no-padding">
    
    <ion-row class="ion-no-padding">
      <ion-col size-xs="12"  class="ion-no-padding">
        <div  *ngIf="noSlotsAvailable" style="padding: 15px 15px 8px 15px; text-transform: uppercase;"><strong>{{ 'PICK_SLOT.NO_SLOTS_AVAILABLE' | translate }}</strong></div>
        <div style="padding: 15px 15px 8px 15px; text-transform: uppercase; color:#11324D;"><strong>{{ selectedDay | momentDate:"fullDate":undefined:translateService.currentLang}}</strong>
          <p *ngIf="!selectedDayHasSlots && !selectedDayIsOpen && real?.provider?.id != 437">{{ 'PICK_SLOT.CLOSED' | translate }}</p>
          <p style="text-transform: none;" *ngIf="!selectedDayHasSlots && !selectedDayIsOpen && real?.provider?.id == 437">{{ 'PICK_SLOT.NO_BOOKINGS_WONDERLAND_DISCLAMER' | translate }}</p>
          <p *ngIf="!selectedDayHasSlots && selectedDayIsOpen">{{ 'PICK_SLOT.NO_SLOTS_AVAILABLE' | translate }}</p>
        </div>

        <!--ion-grid>
          <ion-row>
            <ion-col size-xs="4" style="padding:5px; border: 1px solid black; color: white; background-color:blue; font-size: 11px;" class="ion-text-center ion-no-padding">
              Vse možnosti
            </ion-col>
            <ion-col size-xs="4" style="padding:5px; border: 1px solid blue; color: blue; font-size: 11px;" class="ion-text-center ion-no-padding">
              Prikaži samo termine za<br /><b>Teden restavracij</b>
              <br /><ion-icon name="filter-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-grid-->

        <!--ion-grid>
          <ion-row>
            <ion-col size-xs="4" style="padding:5px; border: 1px solid black; color: white; background-color:blue; font-size: 11px;" class="ion-text-center ion-no-padding">
              Vse možnosti
            </ion-col>
            <ion-col size-xs="4" style="padding:5px; border: 1px solid blue; color: blue; font-size: 11px;" class="ion-text-center ion-no-padding">
              Prikaži samo termine za<br /><b>Teden restavracij</b>
              <br /><ion-icon name="filter-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-grid-->

        <!--div style="margin-right:5px; margin-left:5px;">
          <ion-segment value="default" >
            <ion-segment-button style="font-size:11px;" value="default">
              <ion-label>Teden restavracij</ion-label>
            </ion-segment-button>
            <ion-segment-button style="font-size:11px;" value="event2">
              <ion-label>Jesenska pripoved</ion-label>
            </ion-segment-button>
            <ion-segment-button style="font-size:11px;" value="other">
              <ion-label>Ostali termini</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div-->

        <div style="margin-right:5px; margin-left:5px; margin-bottom:10px;"
             *ngIf="selectedDayObject && selectedDayObject.events.length > 0 && servicesSnapshot">
            
            <!-- Two line segments for 3 or more events -->
            <div *ngIf="selectedDayObject.events.length >= 3">
                <ion-segment class="segment-spacing" mode="ios" (ionChange)="changedEventFilter($event);" [value]="eventFilter">
                    <ion-segment-button style="font-size:11px;" *ngFor="let e of selectedDayObject.events.slice(0, 2)" [value]="e">
                        <ion-label>{{ getEventName(e) }}</ion-label>
                    </ion-segment-button>
                </ion-segment>
                <ion-segment mode="ios" (ionChange)="changedEventFilter($event);" [value]="eventFilter">
                    <ion-segment-button style="font-size:11px;" *ngFor="let e of selectedDayObject.events.slice(2)" [value]="e">
                        <ion-label>{{ getEventName(e) }}</ion-label>
                    </ion-segment-button>
                    <ion-segment-button style="font-size:11px;" value="all">
                        <ion-label>{{ 'PICK_SLOT.ALL_SLOTS' | translate }}</ion-label>
                    </ion-segment-button>
                </ion-segment>
            </div>

            <!-- Single line segment for 2 or less events -->
            <ion-segment *ngIf="selectedDayObject.events.length < 3" [ngClass]="{'hidden-sm-down': selectedDayObject.events.length > 2 }" (ionChange)="changedEventFilter($event);" [value]="eventFilter" mode="ios">
                <ion-segment-button style="font-size:11px;" *ngFor="let e of selectedDayObject.events" [value]="e">
                    <ion-label>{{ getEventName(e) }}</ion-label>
                </ion-segment-button>
                <ion-segment-button style="font-size:11px;" value="all">
                    <ion-label>{{ 'PICK_SLOT.ALL_SLOTS' | translate }}</ion-label>
                </ion-segment-button>
            </ion-segment>
        </div>

        <!--div style="margin-right:5px; margin-left:5px; margin-bottom:10px;" *ngIf="selectedDayObject && selectedDayObject.events.length > 0 && servicesSnapshot">
          <ion-segment [ngClass]="{'hidden-sm-down': selectedDayObject.events.length > 2 }" (ionChange)="changedEventFilter($event);" [value]="eventFilter" mode="ios" >
            <ion-segment-button style="font-size:11px;" *ngFor="let e of selectedDayObject.events" [value]="e">
              <ion-label>{{ getEventName( e ) }}</ion-label>
            </ion-segment-button>
 
            <ion-segment-button style="font-size:11px;" value="all">
              <ion-label>{{ 'PICK_SLOT.ALL_SLOTS' | translate }}</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div-->

        <!--ion-segment style="" value="default">
          <ion-segment-button value="default">
            <ion-label>Teden restavracij</ion-label>
          </ion-segment-button>
          <ion-segment-button value="other">
            <ion-label>Ostali termini</ion-label>
          </ion-segment-button>
        </ion-segment-->

        <ion-grid *ngIf="( loadingMorningSlots || loadingAfternoonSlots )"> 
          <ion-row style="height:100px" class="ion-align-items-center"><ion-col class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
        </ion-grid>

        <app-slots *ngIf="!loadingMorningSlots" [real]="real" [eventFilter]="eventFilter" [slotCombinations$]="slotCombinations$" [slots$]="morningSlots$" [initialSlot$]="initialSlot$" [pick]="pick" [selectedTime]="selectedTime" (onSlotPicked)="toggleSlot($event)"></app-slots>
      </ion-col>




      <ion-col style="margin-bottom:30px;" size-xs="12"  class="ion-no-padding">
        <!--<div><strong>&nbsp;</strong></div>-->
        <app-slots *ngIf="!loadingAfternoonSlots"  [real]="real" [eventFilter]="eventFilter" [slotCombinations$]="slotCombinations$" [slots$]="afternoonSlots$" [initialSlot$]="initialSlot$"  [pick]="pick" [selectedTime]="selectedTime" (onSlotPicked)="toggleSlot($event)"></app-slots>
      </ion-col>

      <!--<ion-col>
        <app-summary [pick]="pick"></app-summary>
        <app-services-summary [pick]="pick"></app-services-summary>
        <div class="btn pull-right pm-button--outline btn-outline-primary" [routerLink]="'../predogled'">Predogled <fa name="chevron-right"></fa></div>
        <div class="btn pull-left pm-button--outline btn-outline-primary" [routerLink]="'../../'"><fa name="chevron-left"></fa> Izberi storitve</div>
      </ion-col>-->

    </ion-row>
  </ion-grid>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="pick?.isCombinationPicked()" mode="md">
  <ion-toolbar  class="ion-no-padding">
    <ion-button [routerLink]="['../../../../predogled']" [color]="('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug)?'primary':'secondary'" expand="full" class="btn--large ion-no-margin bottom-btn">{{ 'PICK_SLOT.BTN_TO_PREVIEW' | translate }}</ion-button>
  </ion-toolbar>
</ion-footer>